// @ts-nocheck
import React, { Component } from 'react';
import classNames from "classnames";
// import { Editor } from '@tinymce/tinymce-react';
import { Editor } from 'ynf-tinper-next-pro';
import { getFileOperationUrl, axiosInstance } from '@utils/request';
import { ENV_RENDER_DESINGER } from '@utils';
import './style/index.less';

const jsonParse = (json: any) => {
  if (typeof json === "object") return json;
  try {
    return JSON.parse(json);
  } catch (e) {
    return {};
  }
};

const defaultPlugins = 'formatpainter preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help emoticons autosave autoresizeF placeholder';
const defaultToolbar = 'fullscreen | undo redo | formatpainter removeformat | blocks fontfamily fontsize bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify lineheight outdent indent | bullist numlist | link unlink | table image media | hr pagebreak';

export default class RichText extends Component<any, any> {
  constructor (props: any) {
    super(props);
    this.state = {
      _value: props.value
    };
    this.editorRef = {};
  }

  UNSAFE_componentWillReceiveProps (nextProps: any) {
    if (this.state._value !== nextProps.value) {
      this.setState({ _value: nextProps.value })
    }
    const nextPropsWrapStyle = jsonParse(nextProps.wrapStyle);
    const propsWrapStyle = jsonParse(this.props.wrapStyle);
    if (nextPropsWrapStyle.height !== propsWrapStyle.height) {
      const richDom: any = this.richtextContainerRef?.querySelector('.tox.tox-tinymce');
      if (richDom) {
        richDom.style.height = nextPropsWrapStyle.height
      }
    }
  }

  initInstance = (evt: any, editor: any) => {
    this.editorRef.current = editor;
    this.props.initInstance?.(editor)
  }

  onEditorChange = async (html: any) => {
    const { onChange } = this.props;
    onChange?.(html);
    this.setState({ _value: html })
  }

  handleBlur = (args: any) => {
    const { onBlur } = this.props;
    onBlur?.(args);
  }

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.props || {};
    return fieldid || fieldidPrefix;
  }

  request = (url, formData, resolve, reject) => {
    axiosInstance({
      url,
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res: any) => {
      if (res.status === 200 && res.data.count === 1) {
        const url = res.data?.data?.[0]?.filePath;
        resolve(url);
      } else {
        reject(res.data?.message || 'Upload failed, please check the upload interface');
      }
    }).catch((e: any) => {
      reject(e)
    })
  }

  getPromise = (file) => {
    const { appCode, serviceCode, pageStore } = this.props;
    const _appCode = appCode || pageStore?.query?.domainKey || 'developplatform';
    const url = getFileOperationUrl(_appCode, serviceCode || pageStore?.query?.serviceCode || "ybbase");
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('files', file);
      formData.append('name', file.name);
      this.request(url, formData, resolve, reject)
    })
  }

  onUpload = async (file: any) => {
    if (file.length) { // 批量上传
      let i = 0;
      const promiseArr = [];
      while (i < file.length) {
        promiseArr.push(this.getPromise(file[i]));
        i++;
      }
      return await Promise.all(promiseArr);
    } else { // 单文件上传
      return await this.getPromise(file);
    }
  }

  initConfig = () => {
    const self = this;
    const { plugins, imageDimensions, language, toolbars, readOnly, placeholder, disabled = false, extendedValidElements, wrapStyle } = this.props;
    const _wrapStyle = jsonParse(wrapStyle);
    let { toolbar } = this.props;
    const _placeholder = placeholder || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A1FE25004C80006', '欢迎使用富文本编辑器', undefined, { returnStr: true })

    if (toolbars?.length && !toolbar) {
      toolbar = toolbars.join(' ');
    }
    const config = {
      language: language || 'zh_CN',
      plugins: plugins || defaultPlugins,
      toolbar: toolbar || defaultToolbar,
      menubar: false, // 隐藏顶部菜单栏
      image_dimensions: imageDimensions || false, // 上传图片不保留宽高
      // elementpath: false, // 隐藏底栏的元素路径
      // branding: false, // 隐藏右下角技术支持
      statusbar: false, // 隐藏
      height: _wrapStyle.height, // 编辑器高度
      min_height: Number.parseInt(_wrapStyle.minHeight), // 编辑器最小高度
      extended_valid_elements: extendedValidElements || 'tplnode[id],div[forprinttag|id|class|style|fieldid|title|widht|height]',
      fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
      font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;', // @notranslate
      // link_list: linkList,
      // image_list: imageList,
      // image_class_list: imageClassList,
      importcss_append: true,
      placeholder: _placeholder,
      disabled: readOnly || disabled,
      convert_urls: false,
      toolbar_sticky: true,
      paste_as_text: false, // 复制粘贴表格
      forced_root_block: 'div', // 内容以div分块(默认是以p分块)
      invalid_elements: "colgroup", // 禁止出现colgroup和li元素
      // autosave_ask_before_unload: true,
      imageUpload: {
        onUpload: self.onUpload
      }
    }
    return config
  }

  render () {
    const { id, renderEnv, readOnly = false, disabled, visible = true, designDomAttr = {}, wrapStyle = {}, singleLine = 'true', horizontally, verticalCenter } = this.props;
    const { _value } = this.state;
    let designStyle = {};
    if (!visible) {
      designStyle = { display: 'none' };
    }

    const wrapCls = classNames({
      'lib-richtext': true,
      'lib-richtext-vertical': singleLine === 'false',
      'lib-richtext-designer': renderEnv === ENV_RENDER_DESINGER
    })

    const readOnlyClassName = classNames('lib-richtext-content', {
      horizontally,
      verticalCenter
    })

    return (
      <div className={wrapCls} {...designDomAttr} style={{ ...designStyle, ...jsonParse(wrapStyle) }}>
        {/* {
          showLabel && caption && ( // 有label且有caption
            <div className='lib-richtext-label' title={caption} style={{ ...jsonParse(labelStyle) }}>
              {<Icon className="required-star" type="uf-mi" style={{ visibility: !readOnly && required ? 'visible' : 'hidden' }} />}
              {caption}
            </div>
          )
        } */}
        <div className={readOnlyClassName} ref={(c) => { this.richtextContainerRef = c }}>
          {
            readOnly
              // eslint-disable-next-line react/no-unknown-property
              ? <div className='lib-richtext-content-readonly' dangerouslySetInnerHTML={{ __html: _value }} fieldid={this.getFieldId()} />
              : <Editor
                onInit={this.initInstance}
                // initialValue={defaultValue}
                onEditorChange={this.onEditorChange}
                value={_value}
                disabled={disabled || readOnly}
                init={this.initConfig()}
                onBlur={this.handleBlur}
                id={id}
              />
          }
          {/* {tips && (
            <Tooltip
              overlayClassName='yy-base-element-tooltip-cont'
              getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
              overlay={(<div style={{ maxWidth: '110px' }}>{tips}</div>)}
              placement="top"
            >
              <Icon className="yy-base-element-tipicon" type="uf-a-wenhaomoren" />
            </Tooltip>
          )} */}
        </div>
      </div>
    )
  }
}
